import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function LocationWarningDialog({ open, onClose }) {
    const navigate = useNavigate();

    const handleProceed = () => {
        navigate('/vendor/settings#map');
    };

    const handleCancel = () => {
        navigate('/vendor/dashboard');
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Location Required</DialogTitle>
            <DialogContent>
                <Typography>Please provide your business address to start adding products.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button variant="contained" color="primary" onClick={handleProceed}>
                    Set Location
                </Button>
            </DialogActions>
        </Dialog>
    );
}

LocationWarningDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
